import { MovableDialog } from '@/components/shared/MovableDialog';
import { type ReactElement } from 'react';

/**
 * Phase UI-13 — Sequence warning modal.
 *
 * Surfaced when the compiler page loads and the
 * /prior-sequences endpoint reports a strictly-lower sequence with
 * Status !== 'Complete'. Lets the operator continue anyway or cancel
 * to address the prior sequence first.
 */

export interface SequenceWarningModalProps {
  readonly isOpen: boolean;
  readonly priorSequenceNumber: string;
  readonly priorStatus: string;
  readonly onProceed: () => void;
  readonly onCancel: () => void;
}



export function SequenceWarningModal({
  isOpen,
  priorSequenceNumber,
  priorStatus,
  onProceed,
  onCancel,
}: SequenceWarningModalProps): ReactElement | null {
  if (!isOpen) return null;
  // phase-movable-dialogs — shared movable shell.
  return (
    <MovableDialog
      persistKey="compiler.sequenceWarning"
      title="Earlier sequence not complete"
      testId="sequence-warning-modal"
      width={480}
      zIndex={1000}
    >
      <>
        <p style={{ margin: 0, fontSize: 13 }}>
          Sequence {priorSequenceNumber} is not yet complete (status:{' '}
          <strong>{priorStatus}</strong>). Proceed anyway?
        </p>
        <div style={{ display: 'flex', gap: 8, justifyContent: 'flex-end' }}>
          <button
            type="button"
            data-testid="sequence-warning-cancel"
            onClick={onCancel}
            style={{
              padding: '6px 14px',
              border: '1px solid var(--border)',
              borderRadius: 4,
              background: 'var(--surface)',
              cursor: 'pointer',
              fontSize: 13,
            }}
          >
            Cancel
          </button>
          <button
            type="button"
            data-testid="sequence-warning-proceed"
            onClick={onProceed}
            style={{
              padding: '6px 14px',
              background: 'var(--accent, #4f46e5)',
              color: '#fff',
              border: 'none',
              borderRadius: 4,
              fontSize: 13,
              fontWeight: 600,
              cursor: 'pointer',
            }}
          >
            Proceed anyway
          </button>
        </div>
      </>
    </MovableDialog>
  );
}
